import { INotCompletedClients } from './interfases';

const STORAGE_KEY = 'notCompletedData';

type NotCompletedStorageTarget = Pick<
  Storage,
  'getItem' | 'setItem' | 'removeItem'
>;

export interface NotCompletedStorageAdapter {
  load: () => INotCompletedClients[];
  save: (items: INotCompletedClients[]) => void;
  clear: () => void;
}

export const purgeSandboxNotCompletedData = (
  target: NotCompletedStorageTarget,
  sandbox: boolean
): void => {
  if (sandbox) target.removeItem(STORAGE_KEY);
};

export const createNotCompletedStorage = (
  target: NotCompletedStorageTarget,
  sandbox: boolean
): NotCompletedStorageAdapter => {
  purgeSandboxNotCompletedData(target, sandbox);
  if (sandbox) {
    let items: INotCompletedClients[] = [];
    return {
      load: () => [...items],
      save: (nextItems) => {
        items = [...nextItems];
      },
      clear: () => {
        items = [];
        target.removeItem(STORAGE_KEY);
      },
    };
  }

  return {
    load: () =>
      JSON.parse(target.getItem(STORAGE_KEY) || '[]') as INotCompletedClients[],
    save: (items) => target.setItem(STORAGE_KEY, JSON.stringify(items)),
    clear: () => target.removeItem(STORAGE_KEY),
  };
};
